export const TestIds = {
    content: 'mesh-container-content',
    inlineContent: 'inline-content',
};
//# sourceMappingURL=constants.js.map